// src/pages/TermsConditions.jsx
import React from 'react';
import { Helmet } from 'react-helmet';
import '../css/TermsConditions.css'; // Update this path if needed

const TermsConditions = () => {
  return (
    <div>
      <Helmet>
        <title>Platinum24 Cabs - Terms & Conditions</title>
        <meta name="description" content="Terms & Conditions of Platinum24 Cabs" />
      </Helmet>

      {/* Breadcrumb section */}
      <div
        className="breadcumb-wrapper"
        // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
      >
        <div className="container z-index-common">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Terms & Conditions</h1>
          </div>
        </div>
      </div>

      {/* Terms & Conditions section */}
      <section className="terms-section">
        <div className="container">
          <div className="row g-0">
            <div className="col-md-7">
              <div className="terms-content">
                <p><b className="highlight">1. Booking Confirmation:</b> All bookings with Platinum24 Cabs are subject to availability and confirmed once payment is completed and a booking ID is issued.</p>

                <p><b className="highlight">2. Payment:</b> Full fare must be paid at the time of booking. Payments can be made online via our portal or through authorized agents.</p>

                <p><b className="highlight">3. Cancellation and Rescheduling:</b> Cancellations or changes to bookings are subject to our policy. Charges may apply depending on the time of cancellation.</p>

                <p><b className="highlight">4. Passenger Responsibility:</b> Passengers are expected to carry valid ID proofs and booking details. We reserve the right to cancel rides without proper verification.</p>

                <p><b className="highlight">5. Baggage Policy:</b> Small hand baggage is allowed. Oversized or excess baggage may incur additional fees.</p>

                <p><b className="highlight">6. Travel Insurance:</b> Platinum24 Cabs does not offer travel insurance. Riders are encouraged to purchase their own if required.</p>

                <p><b className="highlight">7. Safety Regulations:</b> All riders must adhere to safety instructions provided by our drivers. Seatbelt use is mandatory.</p>

                <p><b className="highlight">8. Changes to Itinerary:</b> Platinum24 Cabs reserves the right to modify or cancel rides due to weather, strikes, or any force majeure circumstances.</p>

                <p><b className="highlight">9. Refusal of Service:</b> Service may be denied to individuals violating terms, under the influence, or causing disruption to others.</p>

                <p><b className="highlight">10. Jurisdiction:</b> These terms are governed by Indian laws. All legal disputes will be handled in the Pune jurisdiction.</p>

                <h3>General Policy</h3>
                <p><b className="highlight">Booking Procedure:</b> Rides can be booked via our website, mobile app, or phone support.</p>
                <p><b className="highlight">Customer Support:</b> Our support team is available 24/7 to assist with booking, cancellations, and other inquiries.</p>

                <h3>Refund Policy</h3>
                <p><b className="highlight">Cancellation Charges:</b> Applicable cancellation charges will be deducted based on our policy.</p>
                <p><b className="highlight">Refund Process:</b> Refunds (if applicable) are processed to the original payment method within 7–10 business days.</p>
                <p><b className="highlight">No-Show Policy:</b> Failure to show up at the pickup point at the scheduled time may result in no refund.</p>
              </div>
            </div>
          </div>

          {/* Contact Info */}
          <div className="contact-info">
            <h2>Contact Us</h2>
            <p>If you have any questions or need further clarification, please reach out to us:</p>
            <ul>
              <li>
                <b>Phone:</b>{' '}
                <a href="tel:+917507048333">+91 7507048333</a> {/* Replace with Platinum24's phone */}
              </li>
              <li>
                <b>Email:</b>{' '}
                <a href="mailto:booking@platinum24cab.com">booking@platinum24cab.com</a> {/* Update email */}
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsConditions;
